import React from "react";
import "./Header.css";

function Header() {
  return (
    <header className="header">
      <div className="container header-container">
        <div className="flex items-center gap-2 animate-fade-in">
          <img src="/logo.png" alt="" className="logopic" />
          <a className="logo" href="#top" aria-label="HIA Technologie Group, accueil">
            <span>HIA</span> Technologie Group
          </a>
        </div>

        <nav>
          <ul className="nav-links">
            <li>
              <a href="#services">Services</a>
            </li>
            <li>
              <a href="#about">À propos</a>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
